import React from "react";

const SeoIcon = ({ fill = "#02C9A6" }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M8.66602 12.9997H17.3327M8.66602 16.2497H12.9993M8.66602 9.74967H17.3327M4.76602 4.33301H21.2327C21.9222 4.33301 22.5836 4.60694 23.0712 5.09453C23.5588 5.58212 23.8327 6.24345 23.8327 6.93301V19.0663C23.8327 19.7559 23.5588 20.4172 23.0712 20.9048C22.5836 21.3924 21.9222 21.6663 21.2327 21.6663H4.76602C4.07645 21.6663 3.41513 21.3924 2.92754 20.9048C2.43994 20.4172 2.16602 19.7559 2.16602 19.0663V6.93301C2.16602 6.24345 2.43994 5.58212 2.92754 5.09453C3.41513 4.60694 4.07645 4.33301 4.76602 4.33301Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SeoIcon;
